import React from 'react';
import { FaceScanGuard } from '../../../components/IntelliProve/FaceScanGuard';
import { IntelliProve } from '../../../components/IntelliProve/IntelliProve';
import { useHideNavigationMenu } from '../../../hooks/navigation/useHideNavigationMenu';


export default function FaceScanScreen() {
  useHideNavigationMenu();

  return (
    <FaceScanGuard>
      <IntelliProve />
    </FaceScanGuard>
  );
}
